const KEY_ADOBE_MC = 'adobe_mc';
const KEY_ANALYTICS_CROSS_DOMAIN_TRACKING = 'da_cdt';
const KEY_EMAIL_HINT = 'email_hint';
const KEY_FN = 'fn';
const KEY_CLIENT_ID = 'clientId';
const KEY_CONSENT = 'consent';
const KEY_LANG = 'language';
const KEY_LOCALE = 'locale';
const KEY_LOGIN_MSG = 'login_msg';
const KEY_NUDGE = 'nudge';
const KEY_REALM = 'realm';
const KEY_RETURN_URI = 'return_uri';
const KEY_SCOPE = 'scope';
const KEY_STRATEGY = 'strategy';
const KEY_SUCCESS = 'success';
const KEY_ERROR_DESCRIPTION = 'error_description';
const KEY_REFERRER = 'referrer';
const KEY_PLATFORM = 'platform';
const TRUSTED_PARAMS = [
    KEY_ADOBE_MC,
    KEY_ANALYTICS_CROSS_DOMAIN_TRACKING,
    KEY_EMAIL_HINT,
    KEY_FN,
    KEY_CLIENT_ID,
    KEY_CONSENT,
    KEY_LANG,
    KEY_LOCALE,
    KEY_LOGIN_MSG,
    KEY_NUDGE,
    KEY_REALM,
    KEY_RETURN_URI,
    KEY_SCOPE,
    KEY_STRATEGY,
    KEY_SUCCESS,
    KEY_ERROR_DESCRIPTION,
    KEY_REFERRER,
    KEY_PLATFORM,
];
export class FragmentHandler {
    static stringify(pathname = '', params = {}) {
        let search = '?';
        Object.keys(params).forEach((key) => {
            if (TRUSTED_PARAMS.indexOf(key) !== -1 && Boolean(params[key])) {
                const encoded = encodeURIComponent(params[key]);
                search += `${key}=${encoded}&`;
            }
        });
        const url = `${pathname.startsWith('/') ? '' : '/'}${pathname}${search.substring(0, search.length - 1)}`;
        return url;
    }
    constructor(options = {}) {
        this.currentFragmentString = window.location.hash;
        this.currentFragmentSearchParams = {};
        this.registeredFunctionKey = '';
        this.functions = options.functions;
        this.currentFragmentSearchParams = this.extractSearchParamsFromFragment();
        this.runFunctionFromFragmentSearchParams();
    }
    getFragmentString() {
        const searchParamsString = new URLSearchParams(this.currentFragmentSearchParams).toString();
        return `?${searchParamsString}`;
    }
    getSearchParams() {
        return this.currentFragmentSearchParams;
    }
    runFunctionFromFragmentSearchParams() {
        if (!this.functions || !this.registeredFunctionKey) {
            return undefined;
        }
        const fn = this.functions[this.registeredFunctionKey];
        if (typeof fn === 'undefined') {
            return undefined;
        }
        fn(this);
    }
    extractSearchParamsFromFragment() {
        const inputMatch = /\?(.*)$/.exec(this.currentFragmentString);
        const params = new URLSearchParams(inputMatch ? inputMatch[1] : this.currentFragmentString);
        const searchParams = {};
        params.forEach((value, key) => {
            searchParams[key] = value;
        });
        return Object.assign({}, ...Object.keys(searchParams).map((key) => {
            if (TRUSTED_PARAMS.indexOf(key) === -1) {
                return {};
            }
            if (key === KEY_FN) {
                this.registeredFunctionKey = searchParams[key];
                return {};
            }
            if (searchParams[key] === 'true' || searchParams[key] === 'false') {
                return {
                    [key]: searchParams[key] === 'true',
                };
            }
            return {
                [key]: searchParams[key],
            };
        }));
    }
}
//# sourceMappingURL=FragmentHandler.js.map